import { getSingleHelpRequest, changeHelpRequestStatus, getHelpRequestsCount } from "../../data/dataApi";
import ContentWrapper from "../../views/components/ContentWrapper";
import { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Button } from "react-bootstrap";
import ConfirmationModal from "../../views/components/ConfirmationModal";
import { useUserState } from "../../views/components/UserStateProvider";
import { Link } from "react-router-dom";

const SingleHelpRequest= () => {
    const { setHelpRequests, userCapabilities } = useUserState();

    const [singleHelpRequest, setSingleHelpRequest] = useState();
    const [showResolveModal, setShowResolveModal] = useState(false);
    const [resolveError, setResolveError] = useState();

    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        (async () => {
            const response = await getSingleHelpRequest(id);
                        
            if(response.success) {
                setSingleHelpRequest(response.data.rows[0]);
            }
        })();
    }, [id]);

    const handleChangeHelpRequestStatus = async () => {
        const response = await changeHelpRequestStatus(id, singleHelpRequest.status === "pending" ? "resolve" : "reopen");

        if(response.success) {
            const helpRequestsCountResponse = await getHelpRequestsCount();
            setHelpRequests(helpRequestsCountResponse.data.rows[0].total_count);
            
            setShowResolveModal(true);
        } else {
            setResolveError(response.error.message);
        }
    }

    return (
        <ContentWrapper className="scrollable">
            <div className="back-wrapper">
                <button className="dashboard-tertiary-btn"
                    onClick={() => {
                        if (location.key === 'default') {
                        navigate('/dashboard/history')
                        } else {
                        navigate(-1)
                        }
                    }}>
                    Back
                </button>
            </div>
            <div className="wrapper tif-bg-color-tertiary tif-bg-light-color-white">
                <div className="table-wrapper">
                    <table className="secondary-table w-100">
                        {singleHelpRequest && <tbody className="secondary-body">
                            <tr>
                                <td width={238}><b>Status</b></td>
                                <td>{ singleHelpRequest.status === "pending" ? "Pending" : "Resolved" }</td>
                            </tr>
                            <tr>
                                <td><b>ID</b></td>
                                <td>{singleHelpRequest.id}</td>
                            </tr>
                            <tr>
                                <td><b>User IP</b></td>
                                <td>{singleHelpRequest.user_ip}</td>
                            </tr>
                            <tr>
                                <td><b>Country</b></td>
                                <td>{singleHelpRequest.country}</td>
                            </tr>
                            <tr>
                                <td><b>Time</b></td>
                                <td>{singleHelpRequest.time}</td>
                            </tr>
                            <tr>
                                <td><b>Name</b></td>
                                <td>{singleHelpRequest.name}</td>
                            </tr>
                            <tr>
                                <td><b>Email Address</b></td>
                                <td>{singleHelpRequest.email}</td>
                            </tr>
                            <tr>
                                <td><b>User Message</b></td>
                                <td>{singleHelpRequest.message}</td>
                            </tr>
                            <tr>
                                <td><b>Origin URL</b></td>
                                <td><Link to={singleHelpRequest.origin_url} target="_blank">{singleHelpRequest.origin_url}</Link></td>
                            </tr>
                        </tbody>}
                    </table>
                </div>
                { resolveError && <p className="error-text">{ resolveError }</p> }
                {
                    userCapabilities.includes("update_help_request_status") &&
                    <div className="button-wrapper tif-mt-60">
                        <Button className="dashboard-quarternary-btn" onClick={handleChangeHelpRequestStatus}>{ singleHelpRequest && singleHelpRequest.status === "pending" ? "Mark as Resolved" : "Reopen Request" }</Button>
                    </div>
                }
                {/* <table className="secondary-table w-100 tif-mb-35 tif-mt-85">
                    <thead>
                        <tr>
                            <td>Correspondence with user</td>
                        </tr>
                    </thead>
                </table>
                {correspondence && correspondence.map((item, index) => (
                    <div className="correspondence tif-pt-25 tif-pb-40 tif-pl-20 tif-pr-30 tif-bg-color-bravo tif-bg-light-color-papa tif-mb-30 tif-color-white tif-light-color-november" key={index}>
                        <p className="name tif-mb-10 tif-ls-25"><strong>{item.name}</strong></p>
                        <p className="subject tif-mb-25 tif-ls-25">{item.subject}</p>
                        <p className="message tif-mb-0 tif-ls-25">{item.message}</p>
                        <p className="date tif-mb-0 tif-ls-25">{item.date}</p>
                    </div>
                ))} */}
                    
            </div>
            
            <ConfirmationModal 
                show={showResolveModal}
                changeVisibility={setShowResolveModal} 
                type="success"
                successMessage={ `You have successfully ${ singleHelpRequest && singleHelpRequest.status === "pending" ? "resolved" : "reopened" } this help request.` }
                close={
                    <Button className="dashboard-tertiary-btn" onClick={() => navigate("/dashboard/help-requests")}>
                        Back to Help Request
                    </Button>
                } 
            />
        </ContentWrapper>
    );
}

export default SingleHelpRequest;